import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '../styles/theme';
import { categories } from '../data/categories';

const NavContainer = styled.nav`
  font-family: ${props => props.theme.fonts.body};
  width: 100%;
  background-color: ${props => props.theme.colors.primary};
  margin-top: 20px;
  padding: 0 20px;  
`;

const NavList = styled.ul`
  display: flex;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
  list-style: none;
  padding: 0;
  
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    flex-wrap: wrap;
  }
`;

const NavItem = styled.li`
  position: relative;
  margin: 0 ${props => props.theme.space.sm};
  
  &:hover > ul {
    display: block;
  }
    
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    margin: 0 ${props => props.theme.space.xs};
  }
`;

const NavLink = styled(Link)`
  font-family: ${props => props.theme.fonts.body};
  display: block;
  padding: ${props => props.theme.space.md};
  color: white;
  font-weight: ${props => props.theme.fontWeights.bold};
  font-size: 1.1rem;
  transition: ${props => props.theme.transitions.default};
  text-decoration: none;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }  
`;

const SubNavList = styled.ul`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.border};
  border-top: none;
  min-width: 200px;
  z-index: 10;
  box-shadow: ${theme.shadows.md};
`;

const SubNavItem = styled.li``;

const SubNavLink = styled(Link)`
  font-family: ${theme.fonts.body};
  display: block;
  padding: ${theme.space.sm} ${theme.space.md};
  color: ${theme.colors.text};
  transition: ${theme.transitions.default};
  
  &:hover {
    background-color: ${theme.colors.secondary};
  }
`;

const Navigation: React.FC = () => {
  // スクロールをリセットする関数
  const handleNavClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      <NavContainer>
        <NavList>
          {categories.map((category) => (
            <NavItem key={category.name}>
              <NavLink to={`/category/${category.name}`} onClick={handleNavClick}>{category.name}</NavLink>
              <SubNavList>
                {category.subCategories.map((subCategory) => (
                  <SubNavItem key={subCategory}>
                    <SubNavLink 
                      to={`/category/${category.name}/${subCategory}`}
                      onClick={handleNavClick}
                    >
                      {subCategory}
                    </SubNavLink>
                  </SubNavItem>
                ))}
              </SubNavList>
            </NavItem>
          ))}
        </NavList>
      </NavContainer>      
    </>
  );
};

export default Navigation; 